<template>
  <div>
    <FormFieldsRow
      v-for="(topic, index) in topics"
      :key="'topic-row' + index"
      :index="index"
      :isEditing="!disabled"
      class="mb-4"
    >
      <FormTopic
        :value="topic"
        :editable="!disabled"
        :config="config"
        :formValue="formValue"
        :iteration="iteration"
        :index="index"
        :nestedMode="nestedMode"
        class="p-3"
        @input="updateItem(index, $event)"
        @delete="deleteItem(index)"
      />
    </FormFieldsRow>
    <div
      v-if="!topics || !topics.length"
      class="p-3 mb-2 text-muted bg-light rounded-5 text-center border"
    >No Topics Added</div>
    <AppButton
      v-if="!disabled"
      @click.stop="addItem"
    >
      <AppIcon name="add" />Add Topic
    </AppButton>
  </div>
</template>

<script>
import FormMixin from '@/components/Forms/FormMixin'
import FormTopic from '@/components/Forms/FormTopic'
import FormFieldsRow from '@/components/Forms/FormFieldsRow'
import useFormListWrapper from './composables/useFormListWrapper'

export default {
  mixins: [ FormMixin ],
  components: { FormFieldsRow, FormTopic },
  props: {
    formValue: {
      type: Object,
      default: () => ({}),
    },
    nestedMode: {
      type: Boolean,
      default: true,
    },
    iteration: {
      type: Number,
      default: 0,
    },
  },
  setup (props, { root, emit }) {
    function createEmptyItem () {
      const generatedId = String((props.value?.length ?? 0) + 1) || root.generateToken(5)
      return {
        id: generatedId,
        code: '',
        name: '',
        longName: '',
        description: '',
        repeatable: false,
        numberOfRepeats: 0,
        numberOfCredits: 0,
        link: '',
      }
    }

    const {
      items,
      updateItem,
      addItem,
      deleteItem,
    } = useFormListWrapper({ props, emit, createEmptyItem })

    return {
      topics: items,
      updateItem,
      addItem,
      deleteItem,
    }
  },
}
</script>
